/**
 * 総件数とページサイズから最大ページ数を計算する
 * @param count - 総件数
 * @param perPage - 1ページあたりの件数
 * @returns 最大ページ数（最低1）
 */
const calculateMaxPage = (count: number, perPage: number): number => {
  return Math.max(1, Math.ceil(count / perPage));
};

export default calculateMaxPage;
